<template>
  <div class="main__logo logo">
    <img class="logo__img" src="@/assets/img/logo.svg" />
  </div>
</template>
<script>
export default {
  name: 'Logo'
}
</script>